// extracted by mini-css-extract-plugin
export default {"RunTypeBadge":"RunTypeBadge_RunTypeBadge__9QaQ4"};